module.exports = __webpack_public_path__ + "media/images/Tumblr-4ff834d61c7e29a434d7f38054f8c6b5.png";